import { isArray, isObject, isString } from '@vue/shared'
import { isNil } from 'lodash-es'

export {
  isArray,
  isDate,
  isFunction,
  isObject,
  isPromise,
  isString,
  isSymbol,
} from '@vue/shared'
export { isVNode } from 'vue'

export const isUndefined = (val: any): val is undefined => val === undefined
export const isBoolean = (val: any): val is boolean => typeof val === 'boolean'
export const isNumber = (val: any): val is number => typeof val === 'number'

export const isEmpty = (val: unknown) =>
  (!val && val !== 0) ||
  (isArray(val) && val.length === 0) ||
  (isObject(val) && !Object.keys(val).length)

export const isElement = (e: unknown): e is Element => {
  if (typeof Element === 'undefined') return false
  return e instanceof Element
}

export const isPropAbsent = (prop: unknown): prop is null | undefined => {
  return isNil(prop)
}

export const isStringNumber = (val: string): boolean => {
  if (!isString(val)) {
    return false
  }
  return !Number.isNaN(Number(val))
}

export const isWindow = (val: unknown): val is Window => {
  return val === window
}

export const getType = (typeObj) => {
  // Object.prototype.toString.call(数据)  // 最后返回由"[object"+" "+"class"]"三个部分组成的字符串
  return Object.prototype.toString
    .call(typeObj)
    .slice(
      Object.prototype.toString.call(typeObj).indexOf(' ') + 1,
      Object.prototype.toString.call(typeObj).length - 1
    )
}
